import { render, staticRenderFns } from "./CompetitionSummary2.vue?vue&type=template&id=5d1e7f52&scoped=true"
import script from "./CompetitionSummary2.vue?vue&type=script&lang=js"
export * from "./CompetitionSummary2.vue?vue&type=script&lang=js"
import style0 from "./CompetitionSummary2.vue?vue&type=style&index=0&id=5d1e7f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e7f52",
  null
  
)

export default component.exports